import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import ClubStandings from "./components/ClubStandings";
import Contact from "./components/Contact";
import Error from "./components/Error";
import GeneralRules from "./components/GeneralRules";
import Loader from "./components/Helper/Loader";
import ScrollToTop from "./components/Helper/ScrollToTop";
import HomeOne from "./components/HomeOne";
import SportsBadminton from "./components/SportsBadminton";
import SportsBasketBall from "./components/SportsBasketBall";
import SportsBilliards from "./components/SportsBilliards";
import SportsCarrom from "./components/SportsCarrom";
import SportsChess from "./components/SportsChess";
import SportsFootball from "./components/SportsFootball";
import SportsLadiesTurfCricket from "./components/SportsLadiesTurfCricket";
import SportsLawnTennis from "./components/SportsLawnTennis";
import SportsRelayRace from "./components/SportsRelayRace";
import SportsSquash from "./components/SportsSquash";
import SportsSwimming from "./components/SportsSwimming";
import SportsTableTennis from "./components/SportsTableTennis";
import SportsTurfCricket from "./components/SportsTurfCricket";
import SportsVolleyBall from "./components/SportsVolleyBall";
import YouTubLive from "./components/YouTubLive";

function Routes() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  });
  return (
    <>
      {loading && (
        <div className={`appie-loader ${loading ? "active" : ""}`}>
          <Loader />
        </div>
      )}
      <div className={`appie-visible ${loading === false ? "active" : ""}`}>
        <Router>
          <ScrollToTop>
            <Switch>
              <Route exact path="/" component={HomeOne} />
              <Route exact path="/youtube-live" component={YouTubLive} />
              <Route exact path="/club-standing" component={ClubStandings} />
              <Route exact path="/sports/football" component={SportsFootball} />
              <Route
                exact
                path="/sports/turf-cricket-boys"
                component={SportsTurfCricket}
              />
              <Route
                exact
                path="/sports/turf-cricket-girls"
                component={SportsLadiesTurfCricket}
              />
              <Route
                exact
                path="/sports/volleyball"
                component={SportsVolleyBall}
              />
              <Route
                exact
                path="/sports/basketball"
                component={SportsBasketBall}
              />
              <Route exact path="/sports/snooker" component={SportsBilliards} />
              <Route exact path="/sports/squash" component={SportsSquash} />
              <Route
                exact
                path="/sports/lawn-tennis"
                component={SportsLawnTennis}
              />
              <Route
                exact
                path="/sports/table-tennis"
                component={SportsTableTennis}
              />
              <Route
                exact
                path="/sports/badminton"
                component={SportsBadminton}
              />
              <Route exact path="/sports/chess" component={SportsChess} />
              <Route exact path="/sports/carrom" component={SportsCarrom} />
              <Route exact path="/sports/swimming" component={SportsSwimming} />
              <Route exact path="/sports/sprint" component={SportsRelayRace} />
              {/* <Route
                exact
                path="/sports/throw-ball"
                component={SportsThrowBall}
              /> */}
              <Route exact path="/rules" component={GeneralRules} />
              <Route exact path="/contact" component={Contact} />
              <Route component={Error} />
            </Switch>
          </ScrollToTop>
        </Router>
      </div>
    </>
  );
}

export default Routes;
